import { getStore } from '../store/store';

export function getAssignedCalendarColor(calendarId: string) {
    return getStore().assignedCalendarColors.get(calendarId);
}
